/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { useAppClickHandlers } from '../../hooks/useAppClickHandlers';
import DisambiguationModal, { DisambiguationModalProps } from '../../routes/home/partials/DisambiguationModal';
import { useViewRouterConfig } from '../../routes/home/flavours/hooks/useViewRouterConfig';
import { useHomepageProductCards } from '../../routes/home/flavours/hooks/useHomepageProductCards';
import { ProductCards } from '../../routes/home/flavours/partials/ProductCards';

const AppsMenu = ({ toggleRequestDemoModal }: { toggleRequestDemoModal: () => void }) => {
  const [disambiguationModal, setDisambiguationModal] = useState<DisambiguationModalProps | undefined>(undefined);
  const [isOpen, setOpen] = useState(false);
  const { viewConfig } = useViewRouterConfig({ readOnly: true });
  const clickHandlers = useAppClickHandlers({ toggleRequestDemoModal, shouldOpenInNewTab: true, setDisambiguationModal })
  const productCards = useHomepageProductCards({ view: viewConfig.view, clickHandlers });

  return (
    <div className='apps-menu'>
      {disambiguationModal ? <DisambiguationModal {...disambiguationModal} /> : null}
      <Button className='apps-menu-button' color={isOpen ? 'secondary' : 'transparent'} onClick={() => setOpen(!isOpen)}>
        <i className='fa-solid fa-grid' />
      </Button>
      <div className={`apps-menu-blur ${isOpen ? 'visible' : 'invisible'}`} onClick={() => setOpen(false)} />
      <div className={`apps-menu-menu shadow-lg ${isOpen ? 'visible' : 'invisible'}`}>
        <h3 className='mt-0 text-ThemeHeadingLight'>SOLUTIONS</h3>
        <div className='mt-3 d-flex flex-wrap'>
          <ProductCards cards={productCards} clickHandlers={clickHandlers} mode={'simple'} columns={3} />
        </div>
      </div>
    </div>
  );
}

export default AppsMenu;
